(function () {
  const STYLE_ID = 'zoalin-account-shop-button-style';
  const SOFT_COPY_ATTRIBUTE = 'data-zoalin-account-soft-copy';
  const SOFT_COPY_TEXT = {
    'Sign in or create account': 'rgba(24, 19, 15, .78)',
    'Order history': 'rgba(24, 19, 15, .68)',
    'Account profile': 'rgba(24, 19, 15, .68)'
  };
  const STYLE_TEXT = `
    button[data-testid="login-button"],
    button.bg-purple-primary,
    .bg-purple-primary {
      background: #18130f !important;
      color: #fff !important;
    }

    button[data-testid="login-button"]:hover,
    button.bg-purple-primary:hover,
    .hover_enabled_bg-purple-d0:hover {
      background: #2a211a !important;
      color: #fff !important;
    }

    button[data-testid="login-button"]:focus,
    button[data-testid="login-button"]:focus-visible,
    .focus_enabled_ring-purple-l1:focus,
    .focus-visible_enabled_ring-purple-l1:focus-visible {
      box-shadow: 0 0 0 3px rgba(24, 19, 15, .18) !important;
      outline: none !important;
    }

    [data-testid="shop-login-spinner"] {
      background: #18130f !important;
    }
  `;

  const injectStyle = (root) => {
    if (!root || root.getElementById?.(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = STYLE_TEXT;
    root.appendChild(style);
  };

  const normalizeText = (value) => String(value || '').replace(/\s+/g, ' ').trim();

  const softenAccountCopy = (root) => {
    if (!root?.querySelectorAll) return;

    const isDesktop = window.matchMedia?.('(min-width: 761px)')?.matches !== false;
    const candidates = root.querySelectorAll('h1, h2, h3, h4, p, span, a, button, div');

    candidates.forEach((node) => {
      const text = normalizeText(node.textContent);
      const color = SOFT_COPY_TEXT[text];

      if (!color) {
        if (node.hasAttribute?.(SOFT_COPY_ATTRIBUTE)) {
          node.style.removeProperty(window.zaT("color"));
          node.removeAttribute(SOFT_COPY_ATTRIBUTE);
        }
        return;
      }

      if (!isDesktop) {
        node.style.removeProperty(window.zaT("color"));
        node.removeAttribute(SOFT_COPY_ATTRIBUTE);
        return;
      }

      node.style.setProperty(window.zaT("color"), color, 'important');
      node.setAttribute(SOFT_COPY_ATTRIBUTE, 'true');
    });
  };

  const visit = (root) => {
    if (!root?.querySelectorAll) return;

    softenAccountCopy(root);

    root.querySelectorAll('shop-login').forEach((shopLogin) => {
      if (shopLogin.shadowRoot) injectStyle(shopLogin.shadowRoot);
    });

    root.querySelectorAll('*').forEach((node) => {
      if (node.shadowRoot) visit(node.shadowRoot);
    });
  };

  const patch = () => visit(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patch, { once: true });
  } else {
    patch();
  }

  customElements.whenDefined?.('shopify-account').then(patch).catch(() => {});
  document.addEventListener('shopify:section:load', patch);

  const observer = new MutationObserver(patch);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  let attempts = 0;
  const timer = window.setInterval(() => {
    patch();
    attempts += 1;
    if (attempts > 20) window.clearInterval(timer);
  }, 500);
})();
